import AuthCard from "components/Auth/Card";
import PasswordForm from "components/Auth/PasswordForm";

function CreatePassword() {
  return (
    <AuthCard
      title="Create new password"
      desc="Create a strong and unique password to securely access your CSD portal"
    >
      <PasswordForm />
    </AuthCard>
  );
}

export default CreatePassword;
